import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import SchemaMetadataWidget from "../../components/widgets/schema-metadata/SchemaMetadataWidget";
import SchemaInformationWidget
  from "../../components/widgets/schema-information/SchemaInformationWidget";
import DatasetStatisticsWidget
  from "../../components/widgets/dataset-statistics/DatasetStatisticsWidget";
import {SchemaContext} from "../../components/schema/context/SchemaContext";
import ValidationStatusWidget
  from "../../components/widgets/validation-status/ValidationStatusWidget";

type ManageSchemaProps = {
  schemaId: string;
}

class ManageSchema extends React.Component<ManageSchemaProps> {

  static contextType = SchemaContext;

  render() {
    return (
      <>
        <Row className="py-3" xl={3} lg={3} md={2} sm={1} xs={1}>
          <Col>
            {
              !this.context.loading && this.context.schema && <SchemaMetadataWidget schema={this.context.schema} loading={this.context.loading}
                                    error={this.context.error}/>
            }
          </Col>
          <Col>
            {
              !this.context.loading && this.context.schema && <SchemaInformationWidget schema={this.context.schema} loading={this.context.loading}
                                       error={this.context.error}/>
            }
          </Col>
          <Col>
            {
              !this.context.loading && this.context.schema && <DatasetStatisticsWidget schema={this.context.schema} loading={this.context.loading}
                                       error={this.context.error} stats={this.context.stats}
                                       isBound={this.context.isBound}/>
            }
          </Col>
        </Row>
        <Row className="py-3" xl={3} lg={3} md={2} sm={1} xs={1}>
          <Col>
            {
              this.props.schemaId && <ValidationStatusWidget schemaId={this.props.schemaId} loading={this.context.loading}
                                      error={this.context.error}/>
            }
          </Col>
          <Col></Col>
          <Col></Col>
        </Row>
      </>
    );
  }
}

export default ManageSchema;
